import React, { Fragment, Component } from 'react'

import DayPicker from 'react-day-picker'
import moment from 'moment'

import 'react-day-picker/lib/style.css'
import './daypicker.css'

const getWeekDays = weekStart => {
  const days = [weekStart]

  for (let i = 1; i < 7; i += 1) {
    days.push(
      moment(weekStart)
        .add(i, 'days')
        .toDate()
    )
  }

  return days
}

const getWeekRange = date => ({
  from: moment(date)
    .startOf('isoWeek')
    .toDate(),
  to: moment(date)
    .endOf('isoWeek')
    .toDate(),
})

const getDateByYearMonth = date => new Date(moment(date).year(), moment(date).month())

export default class WeekPicker extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hoverRange: undefined,
      selectedDays: getWeekDays(getWeekRange(moment(props.weekStartDate)).from),
      show: false,
    }
  }

  componentDidUpdate() {
    if (!this.props.weekStartDate.isSame(this.state.selectedDays[0]))
      this.setState({
        selectedDays: getWeekDays(getWeekRange(this.props.weekStartDate).from),
      })
  }

  handleDayChange = date => {
    const selectedDays = getWeekDays(getWeekRange(date).from)

    this.props.selectedWeekStartDate(moment(selectedDays[0]))

    this.setState({
      selectedDays: getWeekDays(getWeekRange(date).from),
      show: false,
    })
  }

  handleDayEnter = date =>
    this.setState({
      hoverRange: getWeekRange(date),
    })

  handleDayLeave = () =>
    this.setState({
      hoverRange: undefined,
    })

  handleWeekClick = (_weekNumber, days, _e) => {
    this.props.selectedWeekStartDate(moment(days[0]))

    this.setState({
      selectedDays: days,
      show: false,
    })
  }

  show = value => this.setState({ show: value })

  render() {
    const { hoverRange, selectedDays } = this.state
    const daysAreSelected = selectedDays.length > 0

    const modifiers = {
      hoverRange,
      selectedRange: daysAreSelected && {
        from: selectedDays[0],
        to: selectedDays[6],
      },
      hoverRangeStart: hoverRange && hoverRange.from,
      hoverRangeEnd: hoverRange && hoverRange.to,
      selectedRangeStart: daysAreSelected && selectedDays[0],
      selectedRangeEnd: daysAreSelected && selectedDays[6],
    }

    return (
      <Fragment>
        {this.props.renderTopContent(this.show, {
          show: this.state.show,
        })}
        {this.state.show && (
          <div className="DayPickerContainer">
            <DayPicker
              modifiers={modifiers}
              month={getDateByYearMonth(this.props.weekStartDate)}
              onDayClick={this.handleDayChange}
              onDayMouseEnter={this.handleDayEnter}
              onDayMouseLeave={this.handleDayLeave}
              onWeekClick={this.handleWeekClick}
              selectedDays={selectedDays}
              showOutsideDays
              showWeekNumbers
            />
          </div>
        )}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/navigate-by-week/views/week-picker.jsx